export default {
  'common.search': 'Buscar',
  'common.explore': 'Explorar',
  'common.login': 'Iniciar sesión',
  'common.logout': 'Cerrar sesión',
  'common.register': 'Registrarse',
  'common.submit': 'Enviar',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.delete': 'Eliminar',
  'common.loading': 'Cargando...',
  'common.processing': 'Procesando...',
  'common.error': 'Error',
  'common.success': 'Éxito',
  'common.warning': 'Advertencia',
  'common.info': 'Información',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.back': 'Volver',
  'common.next': 'Siguiente',
  'common.previous': 'Anterior',
  'common.view': 'Ver',
  'common.edit': 'Editar',
  'common.filters': 'Filtros',
  'common.reset': 'Restablecer',
  'common.apply': 'Aplicar',
  'common.confirmation': 'Confirmación',
  'common.confirm': 'Confirmar',
  'common.close': 'Cerrar',
  'common.language': 'Idioma',
  'common.currency': 'Moneda',
  'common.settings': 'Configuración',
  'common.profile': 'Perfil',
  'common.dashboard': 'Panel de control',
  'common.account': 'Cuenta',
  'common.home': 'Inicio',
  'common.contact': 'Contacto',
  'common.about': 'Acerca de',
  'common.help': 'Ayuda',
  'common.faq': 'FAQ',
  'common.login_required': 'Inicio de sesión requerido',
  'common.login_to_continue': 'Por favor, inicia sesión para continuar',
  'common.login_to_favorite': 'Por favor, inicia sesión para añadir a favoritos',
  'common.login_to_message': 'Por favor, inicia sesión para enviar mensajes',
  'common.login_to_book': 'Por favor, inicia sesión para reservar citas',
  'common.email': 'Correo electrónico',
  'common.password': 'Contraseña',
  'common.remember_me': 'Recordarme',
  'common.forgot_password': '¿Olvidaste tu contraseña?',
  'common.no_account': '¿No tienes una cuenta?',
  'common.have_account': '¿Ya tienes una cuenta?',
  'common.agree_terms': 'Acepto los términos y condiciones',
  'common.error_starting_conversation': 'No se pudo iniciar la conversación. Por favor, inténtalo de nuevo más tarde.',
  'common.login_signup': 'Iniciar sesión / Registrarse',
  'common.and': 'y',
  'common.error_occurred': 'Ocurrió un error',
  'gender.female': 'Mujer',
  'gender.male': 'Hombre',
  'gender.trans': 'Transgénero',
  'Login': 'Iniciar sesión',
  'Register': 'Registrarse',
  'Terms of Service': 'Términos de servicio',
  'Privacy Policy': 'Política de privacidad',
  'Join Now': 'Únete ahora',
  'Sign in': 'Iniciar sesión',
  'Name': 'Nombre',
  'Your name': 'Tu nombre',
  'Email': 'Correo electrónico',
  'Your email address': 'Tu dirección de correo electrónico',
  'Password': 'Contraseña',
  'Your password': 'Tu contraseña',
  'Confirm Password': 'Confirmar contraseña',
  'Confirm your password': 'Confirma tu contraseña',
  'I agree to the': 'Acepto los',
  'Create Account': 'Crear cuenta',
  'Account type': 'Tipo de cuenta',
  'Client': 'Cliente',
  'Escort': 'Escort',
  'Verified': 'Verificado',
  'Online': 'En línea',
  'Touring': 'De gira',
  'View Profile': 'Ver perfil',
  'Message': 'Mensaje',
  'profile.private_access': 'Acceso Privado',
  'common.verified': 'Verificado/a',
  'common.touring': 'De gira',
  'common.registered_date_prefix': 'Registrado/a el',
  'common.profile.last_online': 'Última conexión',
  'common.today': 'hoy',
  'common.total_views': 'Vistas totales',
  'common.admin.tabs.users': 'Usuarios',
  'common.admin.tabs.reports': 'Reportes',
  'common.admin.tabs.verifications': 'Verificaciones',
  'common.admin.tabs.supabase': 'Supabase',
};
